<template>
  <d-row no-gutters class="page-header py-4">
    <d-col col sm="12" class="text-left text-sm-left mb-4 mb-sm-0">
      <div style="display: flex; align-items: center; justify-content: space-between;">
        <h3 class="page-title mb-0">
          <span
            v-if="subtitle"
            class="text-uppercase page-subtitle">
            {{ subtitle }}
          </span>

          {{ title }}
        </h3>

        <div v-if="backButtonLabel || buttonLabel || secondButtonLabel" style="display: flex; gap: 0.5rem;">
          <d-button
            v-if="backButtonLabel"
            theme="primary"
            outline
            @click.prevent="$router.push(backButtonLink)">
            <i class="material-icons">arrow_back</i>
            {{ backButtonLabel }}
          </d-button>

          <d-button
            v-if="buttonLabel"
            theme="success"
            @click.prevent="$router.push(buttonLink)">
            <i class="material-icons">add</i>
            {{ buttonLabel }}
          </d-button>

          <d-button
            v-if="secondButtonLabel"
            theme="success"
            @click.prevent="$router.push(secondButtonLink)">
            <i class="material-icons">add</i>
            {{ secondButtonLabel }}
          </d-button>
        </div>
      </div>
    </d-col>
  </d-row>
</template>

<script>
export default {
  name: 'page-header',
  props: [
    'title',
    'subtitle',
    'buttonLabel',
    'buttonLink',
    'secondButtonLabel',
    'secondButtonLink',
    'backButtonLabel',
    'backButtonLink'
  ]
}
</script>

<style lang="scss">
.page-header {
  .btn {
    position: relative;
    top: -4px;
  }
}

.page-subtitle {
  display: block;
}
</style>
